import { useAppSelector } from '../../global/hooks';
import {
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalFoot,
	ModalHead,
	SaveButton
} from '../../global/styles';
import { useGetArrangementsQuery, useGetUserQuery } from '../../store/apiSlice';
import { selectActiveArrangementId, selectView, setView } from '../../store/appSlice';
import Arrangements from '../Arrangements';
import { useLoadArrangement } from './hooks';
import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useClickAway } from 'react-use';

export default function Load() {
	const dispatch = useDispatch();

	const ref = useRef(null);
	const saveRef = useRef(null);

	const activeArrangementId = useAppSelector(selectActiveArrangementId);
	const isVisible = useAppSelector(selectView) === 'load';
	const closeModal = () => dispatch(setView('main'));

	const { data: user } = useGetUserQuery();
	const { data: arrangements = [], isFetching } = useGetArrangementsQuery(user?.id ?? 0, {
		skip: user == null
	});

	const handleLoadArrangement = useLoadArrangement(arrangements, closeModal);

	useClickAway(ref, () => {}); //closeModal());
	return isVisible ? (
		<Modal ref={ref}>
			<ModalCloseButton
				onClick={closeModal}
				title="close this modal popup"
				aria-label="close this modal poup"
			/>
			<div>
				<ModalHead>Load Arrangement</ModalHead>

				<ModalBody>
					<Arrangements arrangements={arrangements} isLoading={isFetching} />
				</ModalBody>
			</div>

			<ModalFoot>
				<SaveButton
					ref={saveRef}
					disabled={activeArrangementId === null}
					onClick={handleLoadArrangement}
					title={
						activeArrangementId === null
							? 'No arrangement selected'
							: 'Load selected arrangement'
					}
				>
					Load Arrangement
				</SaveButton>
			</ModalFoot>
		</Modal>
	) : null;
}
